// Signal names for the Anthropometric section. Content + Editor render
// side-by-side and coordinate via EventService:
//   ANTH_V2_REFRESH        — emitted after any successful save; Content refetches
//   ANTH_V2_SELECT_PARAM   — emitted when a row is clicked in Content; Editor
//                            opens the matching parameter card
export const ANTH_V2_REFRESH = "anth-v2:refresh";
export const ANTH_V2_SELECT_PARAM = "anth-v2:select-param";
